export const chunkArrayForQuadSwiper = <T>(array: T[], groupSize: number = 4): T[][] => {
  const result: T[][] = [];
  const validLength = Math.floor(array.length / groupSize) * groupSize;

  for (let i = 0; i < validLength; i += groupSize) {
    result.push(array.slice(i, i + groupSize));
  }
  return result;
};
